import React from 'react';
import '../styles/OurMissionPage.css';

const OurMission = () => {
    return (
        <div className="mission-container">
            {/* Hero Section
            <section className="hero-section">
                <div className="overlay"></div>
                <div className="hero-content">
                    <h1>Misyonumuz</h1>
                    <p>
                        MeduVR olarak misyonumuz, sanal gerçeklik teknolojisi kullanarak tıbbi görüntüleme eğitimi, hastane deneyimi ve farkındalığı alanında devrim yaratmak ve kullanıcılarımıza pratik, etkileşimli bir öğrenme deneyimi sunmaktır. Eğitim çözüm ortaklarıyla birlikte geliştirdiğimiz programlar sayesinde sektöre yeni bir bakış açısı ve derinlik kazandırmayı hedefliyoruz. Sağlık profesyonelleri, üniversite öğrencileri, tıbbi görüntüleme cihaz profesyonelleri ve topluma yönelik kapsamlı eğitim içerikleri sunarak tıbbi görüntüleme eğitiminde yenilikçi çözümler üretmekteyiz. Ayrıca, VR teknolojisini kullanarak kadınlara meme sağlığı, mamografi, Kendi Kendine Meme Muayenesi (KKMM) ve Klinik Meme Muayenesi (KMM) gibi konularda deneyim kazandırmayı ve farkındalık sağlamayı amaçlamaktayız.
                    </p>
                </div>
            </section>
*/}
            {/* Mission Details */}
            <section className="mission-details">
                <div className="content-wrapper">
                    <h2>MİSYONUMUZ</h2>
                    <p>
                        MeduVR olarak misyonumuz, sanal gerçeklik teknolojisi kullanarak tıbbi görüntüleme eğitimi,
                        hastane deneyimi ve farkındalığı alanında devrim yaratmak ve kullanıcılarımıza pratik,
                        etkileşimli bir öğrenme deneyimi sunmaktır. Eğitim çözüm ortaklarıyla birlikte geliştirdiğimiz
                        programlar sayesinde sektöre yeni bir bakış açısı ve derinlik kazandırmayı hedefliyoruz. Sağlık
                        profesyonelleri, üniversite öğrencileri, tıbbi görüntüleme cihaz profesyonelleri ve topluma
                        yönelik kapsamlı eğitim içerikleri sunarak tıbbi görüntüleme eğitiminde yenilikçi çözümler
                        üretmekteyiz. Ayrıca, VR teknolojisini kullanarak kadınlara meme sağlığı, mamografi, Kendi
                        Kendine Meme Muayenesi (KKMM) ve Klinik Meme Muayenesi (KMM) gibi konularda deneyim kazandırmayı
                        ve farkındalık sağlamayı amaçlamaktayız.

                    </p>

                </div>
            </section>
        </div>
    );
};

export default OurMission;